import {
  EscalationRequestFormProps,
  EscalationType,
} from "./escalationRequestForm";
import { Attachment, TicketPriority, TicketStatus } from "./tickets";
import { TwilioHelpCenterUser } from "./user";

export interface TicketDetailsViewProps {
  collaborators: string[];
  collaboratorMethods: TicketDetailsViewCollaboratorMethods;
  hasEscalation?: boolean;
  loading: boolean;
  isSubmittingComment: boolean;
  onEscalateTicket: EscalationRequestFormProps["onEscalateTicket"];
  onSubmitComment: (formData: TicketCommentSubmissionArgs) => void;
  successChecks?: TicketDetailsAsyncSuccessChecks;
  ticketDetails: TicketDetailsAttributes;
  user: TwilioHelpCenterUser;
  ticketDetailParameters?: TicketDetailParameters;
}

export interface TicketDetailsViewCollaboratorMethods {
  onCancel: () => void;
  onRemove: (newCollaborators: string[]) => void;
  onSubmit: (newCollaborators: string[]) => void;
}

export interface TicketDetailsAsyncSuccessChecks {
  comment?: boolean;
  collaborators?: boolean;
}

export interface TicketDetailsAttributes {
  comments: TicketComment[];
  createdAt: string;
  emailCcIds: number[];
  escalation?: { type: EscalationType };
  id: number;
  priority: TicketPriority;
  product: TicketProduct;
  status: TicketStatus;
  subject: string;
  requesterId: number;
  tags: string[];
  updatedAt: string;
  users: TicketUser[];
}

export interface TicketDetailParameters {
  escalationDelayIsEnabled: boolean;
  ticketEscalationDelayMinutes: number;
}

export interface TicketAuthor {
  alias: string;
  displayName: string;
  id: number;
  isEndUser: boolean;
  isAuthor: boolean;
  name: string;
}

export interface TicketComment {
  attachments: Attachment[];
  author: TicketAuthor;
  body: string;
  createdAt: string;
  htmlBody: string;
  id: number;
  public: boolean;
}

export interface TicketProduct {
  value: string;
  name: string;
}

export interface TicketUser {
  id: number;
  email: string;
  name: string;
}

export interface TicketResolveWithoutCommentValues {
  status: TicketStatus;
  comment?: never;
  attachments?: never;
}

export interface TicketCommentFormValues {
  attachments?: File[];
  comment: string;
  status?: TicketStatus;
}

export type TicketCommentSubmissionArgs =
  | TicketResolveWithoutCommentValues
  | TicketCommentFormValues;

export enum TicketCommentFormValueType {
  attachments = "attachments",
  comment = "comment",
}

export interface DataToUpdate {
  status?: string;
  comment?: string;
  attachments?: File[];
}

export interface TicketInfoBarProps {
  ticketDetails: TicketDetailsAttributes;
  hasEscalation: boolean;
  escalationTooltipMessage?: string;
}

export enum TicketInfoBarDisplayProperties {
  id = "id",
  priority = "priority",
  updatedAt = "updatedAt",
  status = "status",
  escalation = "escalation",
}

export interface SubmitData {
  additionalInfo: string;
  escalationType: EscalationType;
  ticketId: number;
}

export interface TextareaWithMarkdownProps {
  value?: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
  onBlur?: (value: string) => void;
  onChange?: (value: string) => void;
}

export interface TicketCollaborator {
  action: string;
  user_email?: string;
}
